export default {
  methods: {
    init(page = "", filters = {}) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch("cms/getListings");
          await this.$store.dispatch("cmstag/getTags");
          const params = {};
          if (page) {
            params.filter = JSON.stringify({
              listing: data._id,
              pageCategory: page,
              ...filters,
            });
          } else {
            params.filter = JSON.stringify({
              listing: data._id,
              ...filters,
            });
          }
          const pages = await this.$store.dispatch("cms/getPages", params);
          resolve(pages.data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
